// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.
import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { connect } from 'react-redux';

export interface ProtectedRouteProps extends RouteProps {
  restrictedPath: string;
  authenticationPath: string;
}

const mapStateToProps = (
  state: { authentication: AuthenticationRootState },
  ownProps: Partial<ProtectedRouteProps>
) => {
  return {
    isLoggedIn: !!state.authentication.accessToken,
    isAllowed: true
  };
};

type Props = ProtectedRouteProps & ReturnType<typeof mapStateToProps>;

const ProtectedRoute: React.FC<Partial<Props>> = (props) => {
  let redirectPath = '';
  if (!props.isLoggedIn) {
    redirectPath = props.authenticationPath || '/';
  }
  if (props.isLoggedIn && !props.isAllowed) {
    redirectPath = props.restrictedPath || '/';
  }

  if (redirectPath) {
    const renderComponent = () => <Redirect to={{ pathname: redirectPath }} />;
    return <Route {...props} component={renderComponent} render={undefined} />;
  } else {
    return <Route {...props} />;
  }
};

export default connect(mapStateToProps, null)(ProtectedRoute);
